module.exports = __webpack_public_path__ + "images/category_lp/audio_instrument/store_images/3_9c1b39fbdb2e8a67f9d80c6f8589a79b.png";